var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcImplemento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 2.2915V52.7082H48.125V15.3746L35.0396 2.2915H6.875ZM45.8333 50.4165H9.16667V4.58317H32.0833V18.3332H45.8333V50.4165ZM45.8333 16.0415H34.375V4.58317H34.8333L45.8333 15.5832V16.0415ZM13.75 45.8332H41.25V22.9165H13.75V45.8332ZM22.9167 43.5415V38.9582H29.7917V43.5415H22.9167ZM22.9167 36.6665V32.0832H29.7917V36.6665H22.9167ZM38.9583 43.5415H32.0833V38.9582H38.9583V43.5415ZM38.9583 36.6665H32.0833V32.0832H38.9583V36.6665ZM38.9583 25.2082V29.7915H32.0833V25.2082H38.9583ZM29.7917 25.2082V29.7915H22.9167V25.2082H29.7917ZM16.0417 25.2082H20.625V29.7915H16.0417V25.2082ZM16.0417 32.0832H20.625V36.6665H16.0417V32.0832ZM16.0417 38.9582H20.625V43.5415H16.0417V38.9582ZM29.7917 11.4582H13.75V9.1665H29.7917V11.4582ZM29.7917 16.0415H13.75V13.7498H29.7917V16.0415Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImplemento);
export default __webpack_public_path__ + "static/media/ic_implemento.bfbfc1de0df91ea1f94237c60bda933c.svg";
export { ForwardRef as ReactComponent };